var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareerExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0833 33.3333H22.9167C21.7708 33.3333 20.8333 32.3958 20.8333 31.25H6.27082V39.5833C6.27082 41.875 8.14582 43.75 10.4375 43.75H39.5833C41.875 43.75 43.75 41.875 43.75 39.5833V31.25H29.1667C29.1667 32.3958 28.2292 33.3333 27.0833 33.3333ZM41.6667 14.5833H33.3333C33.3333 9.97917 29.6042 6.25 25 6.25C20.3958 6.25 16.6667 9.97917 16.6667 14.5833H8.33332C6.04166 14.5833 4.16666 16.4583 4.16666 18.75V25C4.16666 27.3125 6.02082 29.1667 8.33332 29.1667H20.8333V27.0833C20.8333 25.9375 21.7708 25 22.9167 25H27.0833C28.2292 25 29.1667 25.9375 29.1667 27.0833V29.1667H41.6667C43.9583 29.1667 45.8333 27.2917 45.8333 25V18.75C45.8333 16.4583 43.9583 14.5833 41.6667 14.5833ZM20.8333 14.5833C20.8333 12.2917 22.7083 10.4167 25 10.4167C27.2917 10.4167 29.1667 12.2917 29.1667 14.5833H20.8125H20.8333Z",
    fill: "#FF8E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1875 44.625C43.2951 44.625 46.625 41.2951 46.625 37.1875C46.625 33.0799 43.2951 29.75 39.1875 29.75C35.0799 29.75 31.75 33.0799 31.75 37.1875C31.75 41.2951 35.0799 44.625 39.1875 44.625Z",
    fill: "#C9E2F4",
    stroke: "#282A3A",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6625 34.2751C41.0291 33.6417 40.1541 33.25 39.1876 33.25C38.2211 33.25 37.3461 33.6417 36.7127 34.2751",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5345 42.5345L48.2468 46.2469",
    stroke: "#282A3A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerExplorer);
export default __webpack_public_path__ + "static/media/career-explorer.0f26219bcb494872c8ced814f1bf9443.svg";
export { ForwardRef as ReactComponent };